export default __webpack_public_path__ + "static/double-app-d22f4c7733b274548dab699dca30512f.png";